import { ca } from '@cian/analytics';

export function trackBannerClick() {
  ca('eventSite', {
    action: 'click',
    category: 'dailyrent_banner',
    label: 'prozhivite_otpusk',
    name: 'oldevent',
    page: {
      siteType: 'mobile',
      extra: {
        trap_type: 'prozhivite_otpusk',
      },
    },
  });
}

export function trackBannerShow() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'dailyrent_banner',
    label: 'prozhivite_otpusk',
    name: 'oldevent',
    page: {
      siteType: 'mobile',
      extra: {
        trap_type: 'prozhivite_otpusk',
      },
    },
  });
}
